import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Divisao } from "./divisao.model";
import { apiName } from "./data.service";

@Injectable()
export class DivisaoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Divisao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Divisao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca divisoes populado com setores
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["area"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/shared/divisao-api.service.ts
 **/